import loadable from '@loadable/component'
import { TopNavigation } from './TopNavigation'
import { Search } from './Search'

export const SubNavigation = loadable(() => import('./SubNavigation'))
export const SubNavigationMenu = loadable(() => import('./SubNavigationMenu'))
export type { SubNavigationProps } from './SubNavigation'
export type { TopNavigationItem, TopNavigationProps } from './TopNavigation'
export { TopNavigation }
export { Search }
